<template>
    <div class="collapsible" id="manip-fluide" :class="stateClass">

        <div class="collapsible-head wrap" id="head-manip-fluide" @click="$emit('openCollapsible','manip-fluide')">
            MANIPULATION DE FLUIDE FRIGORIGÈNE
            <i class="icon-go"></i>
        </div>

        <div class="collapsible-body manip wrap">

            <div class="op-bouteille">

                <ul class="op-fiche">
                    <operation-component
                            v-for="op in ops" :key="op.id"
                            :operation="op"
                            @opDeleted="deleteOp">
                    </operation-component>
                </ul>

                <a href="javascript: void 0" class="btn add-manip" id="op-fiche" @click.prevent="recordOperation">
                    NOUVELLE MANIP
                    <i class="icon-add"></i>
                </a>

            </div>

        </div>

    </div>
</template>

<script>
    import OperationBouteille from '../../../../js/models/OperationBouteille'
    import OperationComponent from './OperationBouteille.vue'

    export default {

        data() {
            return {
                ops: this.operations
            }
        },

        props: {
            operations: {
                type: Array,
                default: []
            },
            open: null,
            idFi: null
        },

        computed: {
            stateClass() {
                if (this.open === 'manip-fluide') {
                    return 'open'
                } else {
                    return ''
                }
            }
        },

        mounted() {

            let op = new OperationBouteille;
            op.
                getOpsForFibsdd(this.$route.params.id)
                .then(list => this.ops = list)
                .catch()

        },

        methods: {

            recordOperation() {
                let op = new OperationBouteille;
                let id = this.$route.params.id;

                op.newManipFluide(id, data => {
                    this.ops.push(data);
                    this.$emit('newManip', [this.ops])
                })
            },

            // AJOUTE UNE OPÉRATION DÉJÀ CONSTRUITE (VALIDÉE DEPUIS LA MODALE D'EXTRACTION VOCALE)
            addValidatedOperation(op) {
                this.ops.push(op);
                this.$emit('newManip', [this.ops])
            },

            deleteOp(id) {
                let newOps = _.reject(this.ops, op => op.id === id[0]);
                this.ops = newOps;
                this.$emit('newManip', [newOps])
            }

        },

        components: {
            OperationComponent
        }

    }
</script>

<style>

    .collapsible-body a#op-fiche {
        background-color: #5698d2;
        color: #fff;
        font-weight: 700;
        width: 190px;
        margin: 15px 0;
        padding-left: 15px;
    }
    /* Style de base pour les blocs */
    .bottom-op {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
    }

    .bottom-op .bottle,.bottom-op .refrigerant,.bottom-op .delete {
        margin: 0 5px 5px 0;
    }

    /* Media query pour écran plus petit (par exemple, moins de 768px de large) */
    @media (max-width: 530px) {
        .bottom-op .bottle, .bottom-op .refrigerant, .bottom-op .delete {
            flex-basis: content; /* Réinitialise la largeur */
        }
    }
</style>



// WEBPACK FOOTER //
// ManipFluide.vue?31aff0ed